// extracted by mini-css-extract-plugin
module.exports = {"power-backup-E":"E_power-backup-E__wsIvO"};